/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#PageHeader {
  // -1px to ensure that the Divider is above the scrollbar
  height: variables.$page-header-height - 1px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: variables.$margin-medium;

  .area {
    display: flex;
    flex-direction: column;
  }

  hr {
    width: 100%;
  }

  .time-chip-placeholder {
    width: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h1 {
    width: 100%;
    text-align: center;
    margin-right: 80px; //width of time chip
  }
}

#PageHeader-nav-appendix {
  padding: variables.$padding-medium;
}
